"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _state = _interopRequireDefault(require("@/libs/state"));

var _default = {
  components: {},
  props: ['buffer', 'message'],
  data: function data() {
    return {
      requestingInput: false
    };
  },
  computed: {},
  methods: {
    urlPreview: function urlPreview(url) {
      _state.default.$emit('mediaviewer.show', url);
    },
    areWeAnOp: function areWeAnOp() {
      var ourNick = this.buffer.getNetwork().nick;
      return this.buffer.isUserAnOp(ourNick);
    },
    isSelf: function isSelf() {
      var user = this.$state.getUser(this.buffer.getNetwork().id, this.message.nick);
      return this.buffer.getNetwork().ircClient.user.nick === user.nick;
    },
    onBan: function onBan(reason) {
      var network = this.buffer.getNetwork();
      network.ircClient.mode(this.buffer.name, '+b', this.message.nick);
    },
    onKick: function onKick(promptedReason) {
      var network = this.buffer.getNetwork();

      var defaultReason = _state.default.setting('buffers.default_kick_reason');

      var reason = promptedReason || defaultReason;
      network.ircClient.raw('KICK', this.buffer.name, this.message.nick, reason);
    },
    openQuery: function openQuery() {
      var network = this.buffer.getNetwork();

      var buffer = _state.default.addBuffer(network.id, this.message.nick);

      _state.default.setActiveBuffer(network.id, buffer.name);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageInfo"]
window._kiwi_exports.components.MessageInfo = exports.default ? exports.default : exports;
